
import { BrowserRouter } from 'react-router-dom'
import { AppRoutes } from './router'
import { AuthProvider } from './context/AuthContext'
import SelectUdaDialog from './modules/core/auth/components/SelectUdaDialog'
import { RouteProvider } from './context/RouteContext'
import { ThemeProvider } from './context/ThemeContext'
import { LanguageProvider } from './context/LanguageContext'
import { FontSizeProvider } from './context/FontSizeContext'
import { UserProvider } from './lib/contexts/UserContext'
import { QueryProvider } from './providers/QueryProvider'
import { StoreProvider } from './providers/StoreProvider'
import { ThemeProvider as MuiThemeProvider } from '@mui/material/styles'
import { muiTheme } from './theme/muiTheme'
import { SnackbarProvider } from 'notistack'
import { SessionProvider } from './context/SessionContext'
import GlobalErrorHandler from './components/GlobalErrorHandler'
import ReportIssueButton from './components/ReportIssueButton'
import GlobalNewTicketModal from './components/GlobalNewTicketModal'

declare const __BASE_PATH__: string;

function App() {
  return (
    <BrowserRouter basename={__BASE_PATH__}>
      {/*
        THE MUI THEME EXISTS FOR ONE REASON: LAYER ORDER. See theme/muiTheme.ts.
        The shell's sidebar is z-[6000], so MUI's default modal layer of 1300 put
        every dialog under the navigation — and the per-dialog workaround for
        that (zIndex 7000) put every Select menu, opened from inside a dialog,
        behind the dialog. Wrapping everything settles it once.

        Outermost of the providers because notistack and every module read the
        MUI theme, and nothing below it should render against a different one.
      */}
      <MuiThemeProvider theme={muiTheme}>
      {/* Global Error Handler - Centralized API error toast system */}
      <GlobalErrorHandler />

      <SnackbarProvider
        maxSnack={3}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        autoHideDuration={3000}
        classes={{
          containerRoot: 'snackbar-container-custom'
        }}
      >
        <QueryProvider>
          <StoreProvider>
            <ThemeProvider>
              <FontSizeProvider>
                <LanguageProvider>
                  <AuthProvider>
                    {/* The UDA question, asked as a dialog over whatever page the password
                        was submitted from. Mounted here, directly inside AuthProvider, so
                        no sign-in entry point can skip it — and outside the router, so it
                        survives the navigation that follows a successful login. Renders
                        nothing unless a choice is actually pending. */}
                    <SelectUdaDialog />
                    <RouteProvider>
                      <UserProvider>
                        <SessionProvider>
                          <AppRoutes />
                          {/* App-wide (all layouts): floating screenshot popup + New Ticket modal */}
                          <ReportIssueButton />
                          <GlobalNewTicketModal />
                        </SessionProvider>
                      </UserProvider>
                    </RouteProvider>
                  </AuthProvider>
                </LanguageProvider>
              </FontSizeProvider>
            </ThemeProvider>
          </StoreProvider>
        </QueryProvider>
      </SnackbarProvider>
      </MuiThemeProvider>
    </BrowserRouter>
  )
}

export default App
